import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XCircleIcon, LoaderIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
type PaymentStatus = 'loading' | 'success' | 'error' | 'no_data';
export function PaymentConfirmation() {
  const [status, setStatus] = useState<PaymentStatus>('loading');
  const navigate = useNavigate();
  useEffect(() => {
    const confirmPayment = async () => {
      try {
        // Recuperar datos del localStorage
        const pendingDataStr = localStorage.getItem('canjee_pending_payment');
        if (!pendingDataStr) {
          setStatus('no_data');
          return;
        }
        const pendingData = JSON.parse(pendingDataStr);
        // Enviar confirmación de pago a Formspree
        const formData = new FormData();
        formData.append('name', pendingData.name);
        formData.append('email', pendingData.email);
        formData.append('phone', pendingData.phone);
        formData.append('company', pendingData.company);
        formData.append('rut', pendingData.rut);
        formData.append('volume', pendingData.volume);
        formData.append('intent', 'pay_completed');
        formData.append('status', 'paid');
        formData.append('payment_timestamp', new Date().toISOString());
        formData.append('original_timestamp', pendingData.timestamp);
        const response = await fetch('https://formspree.io/f/meopblqb', {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json'
          }
        });
        if (response.ok) {
          // Limpiar localStorage
          localStorage.removeItem('canjee_pending_payment');
          setStatus('success');
        } else {
          setStatus('error');
        }
      } catch (error) {
        console.error('Error al confirmar pago:', error);
        setStatus('error');
      }
    };
    confirmPayment();
  }, []);
  const handleGoHome = () => {
    navigate('/');
  };
  if (status === 'loading') {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-413">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center" data-id="element-414">
          <LoaderIcon className="w-16 h-16 text-indigo-900 mx-auto mb-4 animate-spin" data-id="element-415" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-416">
            Confirmando tu pago...
          </h2>
          <p className="text-gray-600" data-id="element-417">
            Por favor espera mientras procesamos tu información.
          </p>
        </div>
      </div>;
  }
  if (status === 'success') {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-418">
        <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8" data-id="element-419">
          <div className="text-center mb-6" data-id="element-420">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-4" data-id="element-421">
              <CheckCircle2Icon className="w-12 h-12 text-green-600" data-id="element-422" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-423">
              ¡Pago confirmado! 🎉
            </h2>
            <p className="text-lg text-gray-600 mb-6" data-id="element-424">
              Ya eres parte del <strong data-id="element-425">Club Beta de Canjee</strong>
            </p>
          </div>
          <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-6 mb-6" data-id="element-426">
            <h3 className="font-bold text-indigo-900 mb-3" data-id="element-427">
              ¿Qué sigue ahora?
            </h3>
            <ul className="space-y-2 text-sm text-gray-700" data-id="element-428">
              <li className="flex items-start gap-2" data-id="element-429">
                <CheckCircle2Icon className="w-5 h-5 text-indigo-900 flex-shrink-0 mt-0.5" data-id="element-430" />
                <span data-id="element-431">
                  Recibirás un correo de confirmación con todos los detalles
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-432">
                <CheckCircle2Icon className="w-5 h-5 text-indigo-900 flex-shrink-0 mt-0.5" data-id="element-433" />
                <span data-id="element-434">Te avisaremos cuando estemos cerca del go-live</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-435">
                <CheckCircle2Icon className="w-5 h-5 text-indigo-900 flex-shrink-0 mt-0.5" data-id="element-436" />
                <span data-id="element-437">Tendrás acceso anticipado antes que nadie</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-438">
                <CheckCircle2Icon className="w-5 h-5 text-indigo-900 flex-shrink-0 mt-0.5" data-id="element-439" />
                <span data-id="element-440">Tus 6 meses del Plan Básico se activarán al lanzar</span>
              </li>
            </ul>
          </div>
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6" data-id="element-441">
            <p className="text-sm text-amber-900" data-id="element-442">
              <strong data-id="element-443">Recuerda:</strong> Tienes garantía de reembolso 100% hasta
              30 días después del go-live si no estás satisfecho.
            </p>
          </div>
          <button onClick={handleGoHome} className="w-full px-6 py-3 bg-indigo-900 text-white font-semibold rounded-xl hover:bg-indigo-800 transition-all" data-id="element-444">
            Volver al inicio
          </button>
        </div>
      </div>;
  }
  if (status === 'no_data') {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-445">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center" data-id="element-446">
          <XCircleIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" data-id="element-447" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-448">
            No se encontraron datos
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-449">
            No pudimos encontrar información de tu registro. Por favor intenta
            registrarte nuevamente.
          </p>
          <button onClick={handleGoHome} className="w-full px-6 py-3 bg-indigo-900 text-white font-semibold rounded-xl hover:bg-indigo-800 transition-all" data-id="element-450">
            Volver al inicio
          </button>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-451">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center" data-id="element-452">
        <XCircleIcon className="w-16 h-16 text-red-500 mx-auto mb-4" data-id="element-453" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-454">
          Error al confirmar el pago
        </h2>
        <p className="text-gray-600 mb-6" data-id="element-455">
          Hubo un problema al procesar tu confirmación. Por favor contáctanos a
          soporte@canjee.cl
        </p>
        <button onClick={handleGoHome} className="w-full px-6 py-3 bg-indigo-900 text-white font-semibold rounded-xl hover:bg-indigo-800 transition-all" data-id="element-456">
          Volver al inicio
        </button>
      </div>
    </div>;
}